import {ChequeCotizacionListFilter} from "../models/cotizacion-list-filter.model";
import {MovimientoListFilter} from "../models/movimiento-list-filter.model";

export class GetMovimientoListAction {
  static readonly type = '[Movimiento] GetMovimientoListAction';
  constructor() {}
}
export class GetMovimientoAction {
  static readonly type = '[Movimiento] GetMovimientoAction';
  constructor(public payload: {movimientoId}) {}
}
export class CreateMovimientoAction {
  static readonly type = '[Movimiento] CreateMovimientoAction';
  constructor(public payload: {userReceiverId:any, importe:any}) {}
}

export class SearchMovimientoListAction {
  static readonly type = "[Cheque] SearchMovimientoListAction";
  constructor(public payload: { filter: MovimientoListFilter }) {}
}
export class ResetMovimientoListFilter {
  static readonly type = "[Transaccion] ResetMovimientoListFilter";
  constructor() {}
}
